import { styled } from '@mui/material';

const PREFIX = 'FirmItems';

export const firmItemsClasses = {
  showMoreLess: `${PREFIX}-showMoreLess`,
};

export const FirmItemsRoot = styled('div')(({ theme }) => ({
  width: '100%',
  [`& .${firmItemsClasses.showMoreLess}`]: {
    fontSize: '0.875rem',
    color: theme.palette.grey[400],
  },
}));